import { Cell } from '@dealstack/frontend/shared/components/Table/DefaultTable/Cell';
import { Row } from '@dealstack/frontend/shared/components/Table/DefaultTable/Row';
import styled, { css } from 'styled-components';

export const RowWrapper = styled.div<{ isInvalid: boolean; hasIndexColumn?: boolean }>`
	${Row} {
		min-height: 2.5em;

		${({ isInvalid }) =>
			isInvalid &&
			css`
				align-items: start;
			`};
	}

	${Cell}:first-child {
		display: flex;

		${({ hasIndexColumn, isInvalid }) =>
			hasIndexColumn &&
			css`
				justify-content: center;
				align-items: center;
				${isInvalid && ' margin-top:0.6em;'}
			`};
	}
`;
